export const BNK_STMT_flushAPICallsDataReducer = {
  BNK_STMT_flushAPICallsData: (state, action) => {
    state.s3FileUploadAPICall = {
      uploadFileResponses: [null, null, null, null],
      response: {},
      isLoading: false,
      isError: false,
      isSuccess: false,
    };
    state.bsVerifyTxnAPICall = {
      response: {},
      isLoading: false,
      isError: false,
      isSuccess: false,
    };
    state.saveBsDocUploadAPICall = {
      response: {},
      isLoading: false,
      isError: false,
      isSuccess: false,
    };
  },
};
